import { render, staticRenderFns } from "./FbPostsDialogPageSelectionView.vue?vue&type=template&id=121edaa9&scoped=true&"
import script from "./FbPostsDialogPageSelectionView.vue?vue&type=script&lang=js&"
export * from "./FbPostsDialogPageSelectionView.vue?vue&type=script&lang=js&"
import style0 from "./FbPostsDialogPageSelectionView.vue?vue&type=style&index=0&id=121edaa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121edaa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VList,VListItem,VListItemAction,VListItemContent,VListItemGroup,VRadio,VRadioGroup,VVirtualScroll})
